import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OccDaysToArrivalComponent } from '../occ_days_to_arrival/occ_days_to_arrival.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OccDaysToArrivalService } from '../occ_days_to_arrival.service';
import { OccDaysToArrival } from '../occ_days_to_arrival';

@Component({
    selector: 'app-occDaysToArrivalComponent-list',
    templateUrl: './occ_days_to_arrival-list.component.html',
    styleUrls: ['./occ_days_to_arrival-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OccDaysToArrivalListComponent implements OnInit {
	constructor(
		private occDaysToArrivalservice: OccDaysToArrivalService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = occDaysToArrivalservice.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	occDaysToArrivals: any;
	occDaysToArrivalComponent: OccDaysToArrival;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'occDaysToArrivalId', header: 'Id', width: 'auto' },
		{ field: 'days', header: 'days', width: 'auto' },
		{ field: 'pct', header: 'pct', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.occDaysToArrivalId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-occDaysToArrivalComponent-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.occDaysToArrivalservice.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.occDaysToArrivals = res.data.occDaysToArrivals;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.occDaysToArrivals = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	getDeviationLabel(deviationId: number): any {
		// const found = this.occDeviationDropdown?.find(d => d.value === deviationId);
		// return found ? found.label : '';
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(occDaysToArrivalComponent: OccDaysToArrival) {
		try {
			this.formLoading = true;
			this.occDaysToArrivalservice.update(occDaysToArrivalComponent)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.occDaysToArrivals.map((occDaysToArrivalComponent, i) => {
							if (occDaysToArrivalComponent.occDaysToArrivalId === res.data.occDaysToArrivalComponent.occDaysToArrivalId) {
								this.occDaysToArrivals[i] = res.data.occDaysToArrivalComponent;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(occDaysToArrivalComponent: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(occDaysToArrivalComponent));

			this.formLoading = true;
			this.occDaysToArrivalservice.delete(occDaysToArrivalComponent.occDaysToArrivalId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.occDaysToArrivals.splice(this.occDaysToArrivals.indexOf(occDaysToArrivalComponent), 1);
						this.recordTotal = this.occDaysToArrivals.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OccDaysToArrival ' + occDaysToArrivalComponent.occDaysToArrivalId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OccDaysToArrival ' + occDaysToArrivalComponent.occDaysToArrivalId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OccDaysToArrival'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccDaysToArrivalComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOccDaysToArrivalCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(occDaysToArrivalComponent: OccDaysToArrival) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			occDaysToArrivalComponent: occDaysToArrivalComponent,
			title: 'Edit OccDaysToArrival'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccDaysToArrivalComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOccDaysToArrivalCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOccDaysToArrivalCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOccDaysToArrivalCB(occDaysToArrivalComponent: OccDaysToArrival) {
		console.log('Adding OccDaysToArrival: ' + JSON.stringify(occDaysToArrivalComponent));
		// if we don't have a occDaysToArrivals array yet...
		if (!this.occDaysToArrivals) {
			this.occDaysToArrivals = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.occDaysToArrivals.unshift(occDaysToArrivalComponent);

		// no idea what this is but it is required to update the array
		this.occDaysToArrivals = [...this.occDaysToArrivals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDaysToArrival ' + occDaysToArrivalComponent.occDaysToArrivalId + ' Added', life: 3000 });
	}

	updateOccDaysToArrivalCB(occDaysToArrivalComponent: OccDaysToArrival) {
		console.log('Updating OccDaysToArrival: ' + JSON.stringify(occDaysToArrivalComponent));
		let itemIndex = this.occDaysToArrivals.findIndex((item: any) => item.occDaysToArrivalId === occDaysToArrivalComponent.occDaysToArrivalId);
		this.occDaysToArrivals[itemIndex] = occDaysToArrivalComponent;

		// no idea what this is but it is required to update the array
		this.occDaysToArrivals = [...this.occDaysToArrivals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDaysToArrival ' + occDaysToArrivalComponent.occDaysToArrivalId + ' Updated', life: 3000 });
	}

	deleteOccDaysToArrivalCB(occDaysToArrivalComponent: OccDaysToArrival) {
		console.log('Removing OccDaysToArrival: ' + occDaysToArrivalComponent);
		this.occDaysToArrivals.splice(this.occDaysToArrivals.indexOf(occDaysToArrivalComponent), 1);
		this.recordTotal = this.occDaysToArrivals.length;

		// no idea what this is but it is required to update the array
		this.occDaysToArrivals = [...this.occDaysToArrivals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDaysToArrival ' + occDaysToArrivalComponent.occDaysToArrivalId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.occDaysToArrivals ? this.first === (this.occDaysToArrivals.length - this.rows) : true; }
	isFirstPage(): boolean { return this.occDaysToArrivals ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(occDaysToArrivalComponent: any) {
		if (occDaysToArrivalComponent?.status) {
			const status = this.statuses.find((e: any) => e.value == occDaysToArrivalComponent.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
